// import { formatRole } from '@/helpers/permission'
import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingRoleList: false,
  loadingCreateAcc: false,
  loadingDeleteAcc: false,
  loadingDeleteRole: false,
  loadingCreateRole: false,
  loadingAdminList: false,
  pagination: {
    page: 1,
    limit: 10,
    total: -1,
  },
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_ROLE_LIST: (s, data) => (s.loadingRoleList = data),
    LOAD_CREATE_ACCOUNT: (s, data) => (s.loadingCreateAcc = data),
    LOAD_DELETE_ACCOUNT: (s, data) => (s.loadingDeleteAcc = data),
    LOAD_DELETE_ROLE: (s, data) => (s.loadingDeleteRole = data),
    LOAD_CREATE_ROLE: (s, data) => (s.loadingCreateRole = data),
    LOAD_ADMIN_LIST: (s, data) => (s.loadingAdminList = data),
    SET_PAGINATION: (s, data) => (s.pagination = data),
  },

  actions: {
    async getRoleList({ commit }, params) {
      commit("LOAD_ROLE_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/roles", { params });
        const data = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_ROLE_LIST", false);
      }
    },
    async createAccount({ commit }, param) {
      commit("LOAD_CREATE_ACCOUNT", true);

      try {
        const res = await this.$api.post("/v1/portal/users", {
          ...param,
        });

        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_ACCOUNT", false);
      }
    },
    async createAdmin({ commit }, param) {
      commit("LOAD_CREATE_ACCOUNT", true);

      try {
        const res = await this.$api.post("/v1/portal/admin-users", {
          ...param,
        });

        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_ACCOUNT", false);
      }
    },
    async updateInfoAdmin({ commit }, param) {
      commit("LOAD_CREATE_ACCOUNT", true);
      const { userId, ...rest } = param;
      try {
        const res = await this.$api.put(
          `/v1/portal/admin-users/${userId}`,
          rest
        );

        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_ACCOUNT", false);
      }
    },
    async setUserRole({ commit }, param) {
      commit("LOAD_CREATE_ACCOUNT", true);
      const { roleId, userId } = param;
      try {
        const res = await this.$api.post(`/v1/portal/roles/${roleId}/users`, {
          userId,
        });
        if (res.data) {
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_ACCOUNT", false);
      }
    },
    async updateUserVerifyStatus({ commit }, param) {
      commit("LOAD_CREATE_ACCOUNT", true);
      const { isVerified, userId } = param;
      try {
        const res = await this.$api.put(
          `/v1/portal/users/${userId}/verify-status`,
          {
            isVerified,
          }
        );
        if (res.data) {
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_ACCOUNT", false);
      }
    },
    async deleteUser({ commit }, userId) {
      commit("LOAD_DELETE_ACCOUNT", true);
      try {
        const res = await this.$api.delete(`/v1/portal/users/${userId}`);
        if (res) return true;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_ACCOUNT", false);
      }
    },
    async deleteRole({ commit }, roleId) {
      commit("LOAD_DELETE_ROLE", true);
      try {
        const res = await this.$api.delete(`/v1/portal/roles/${roleId}`);
        if (res) return true;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_ROLE", false);
      }
    },
    async createRole({ commit }, payloads) {
      commit("LOAD_CREATE_ROLE", true);
      try {
        const res = await this.$api.post("/v1/portal/roles", payloads);
        if (res) return true;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_ROLE", false);
      }
    },
    async getAdminList({ commit }, params) {
      commit("LOAD_ADMIN_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/admin-users", { params });
        const { data, pagination } = res.data;
        commit("SET_PAGINATION", pagination);
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_ADMIN_LIST", false);
      }
    },
  },
};
